import { gsap, ScrollTrigger } from '../global/gsap';

const initFeaturedEvent = (section) => {
    const banner = section.querySelector('.js-content');

    gsap.set(banner, {
        y: 40,
        opacity: 0
    });

    const showBanner = (show) => {
        gsap.to(banner, {
            opacity: show ? 1 : 0,
            y: show ? 0 : 50,
            duration: 0.4,
            ease: "Power1.out"
        });
    };

    const mm = gsap.matchMedia();

    mm.add({
        isDesktop: "(min-width: 900px)",
        isMobile: "(max-width: 899px)"
    }, (context) => {
        const { isDesktop, isMobile } = context.conditions;

        const startPos = isDesktop ? 'top 70%' : 'top 90%';
        const endPos = isDesktop ? 'top 8%' : 'top 5%';

        ScrollTrigger.create({
            trigger: banner,
            start: startPos,
            end: endPos,
            pinSpacing: false,
            onToggle: (self) => showBanner(self.isActive)
        });
    });
};

export default initFeaturedEvent;
